import React from 'react';
import { Warning as WarningIcon } from '@material-ui/icons';
import Modal from '../../../../Shared/Modal';
import RoundedButton from '../../../../Shared/RoundedButton';

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  isDeleting,
  deleteModalStep,
  currentSurvey,
  classes,
}) => {
  return (
    <Modal
      open={open}
      classes={{ paper: classes.deleteModal }}
      title={deleteModalStep === 1 ? "Delete Instant Assessment" : "Final Confirmation"}
      handleClose={onClose}
    >
      <div className={classes.deleteModalContent}>
        {deleteModalStep === 1 ? (
          <>
            <WarningIcon className={classes.deleteWarningIcon} />
            <h2 className={classes.deleteModalTitle}>
              Delete Instant Assessment?
            </h2>
            <p className={classes.deleteModalMessage}>
              Are you sure you want to permanently delete<br />
              <span className={classes.surveyNameHighlight}>"{currentSurvey?.title}"</span>?
            </p>
            <div className={classes.deleteWarningMessage}>
              This action cannot be undone. All data associated with this assessment will be
              permanently deleted.
            </div>
          </>
        ) : (
          <>
            <h2 className={classes.deleteModalTitle}>
              This action is irreversible
            </h2>
            <p className={classes.deleteModalMessage}>
              Assessment: <span className={classes.surveyNameHighlight}>"{currentSurvey?.title}"</span>
            </p>
            <p className={classes.deleteModalMessage}>
              You are about to permanently delete this assessment configuration. This action cannot be undone and will remove all settings and configuration data.
            </p>
          </>
        )}
      </div>

      <div className={classes.deleteModalActions}>
        <RoundedButton
          variant="outlined"
          color="primary"
          size="medium"
          onClick={onClose}
          disabled={isDeleting}
          className={classes.deleteModalButton}
        >
          Cancel
        </RoundedButton>
        <RoundedButton
          variant="contained"
          size="medium"
          onClick={onConfirm}
          isLoading={isDeleting}
          className={`${classes.deleteModalButton} ${classes.deleteConfirmButton}`}
        >
          {deleteModalStep === 1 ? 'Continue' : 'Delete Permanently'}
        </RoundedButton>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;